import { useCssVariable } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import type { CSSProperties, FC } from 'react';
import {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import styles from './styles.module.scss';
import type { Props } from './types';

export const ExpandContentComponent: FC<Props> = ({
  height,
  children,
  className,
  containerClassName,
  buttonClassName,
  expandButtonText = 'Show More',
  collapseButtonText = 'Show Less',
  isExpanded,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showMore, setShowMore] = useState(false);
  const showLabel = useMemo(
    () => (showMore || isExpanded ? collapseButtonText : expandButtonText),
    [showMore, collapseButtonText, expandButtonText, isExpanded],
  );

  const { setCssVariable } = useCssVariable({
    targetElRef: ref,
  });

  useEffect(() => {
    setCssVariable(
      styles.contentHeightVarName,
      `${height}px`,
    );
  }, [height, setCssVariable]);

  const showHeight = useMemo(() => {
    const scrollHeight = ref.current?.scrollHeight;
    return `${scrollHeight}px`;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, showMore]);

  return (
    <div className={className}>
      <div
        ref={ref}
        className={cx(
          styles.containerExpandWrapper,
          showMore || isExpanded ? styles.isExpanded : null,
          containerClassName,
        )}
        style={{ '--content-height': showHeight } as CSSProperties}>
        {children}
      </div>
      <button
        className={cx(
          styles.btnShow,
          showMore || isExpanded ? styles.isExpanded : null,
          buttonClassName,
        )}
        onClick={() => setShowMore(!showMore)}>
        <span className={styles.textShow}>
          {showLabel}
        </span>
        <span className={styles.iconShowBtn} />
      </button>
    </div>
  );
};
